import React from 'react'
import { IconProps, IconWrapper } from './IconWrapper'

const renderIcon = (color: string) => (
    <path
        d='M12.8332 9.16667V15.5833M9.1665 9.16667V15.5833M5.49984 5.5V16.3167C5.49984 17.3434 5.49984 17.8565 5.69966 18.2486C5.87543 18.5936 6.15569 18.8746 6.50065 19.0504C6.89244 19.25 7.40558 19.25 8.43034 19.25H13.5693C14.5941 19.25 15.1065 19.25 15.4983 19.0504C15.8432 18.8746 16.1244 18.5936 16.3002 18.2486C16.4998 17.8568 16.4998 17.3443 16.4998 16.3195V5.5M5.49984 5.5H7.33317M5.49984 5.5H3.6665M7.33317 5.5H14.6665M7.33317 5.5C7.33317 4.64577 7.33317 4.21887 7.47272 3.88196C7.6588 3.43274 8.01546 3.07563 8.46468 2.88955C8.80159 2.75 9.22894 2.75 10.0832 2.75H11.9165C12.7707 2.75 13.1978 2.75 13.5348 2.88955C13.984 3.07563 14.3408 3.43274 14.5269 3.88196C14.6664 4.21887 14.6665 4.64578 14.6665 5.5M14.6665 5.5H16.4998M16.4998 5.5H18.3332'
        stroke={color}
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
    />
)

export const Trash: React.FC<IconProps> = ({ color, size }) => (
    <IconWrapper {...{ size, color, renderIcon }} viewBox={'0 0 22 22'} />
)
